const axios = require("axios");
import AUTHENTICATION from "@/data/authentication.yml";
import dynamicLocalization from "@/mixins/dynamic-localization";

const LOGIN_STATES = {
  AUTHORIZING: 0,
  AUTHORIZED: 1,
  FAILED: 2,
};

export default {
  mixins: [dynamicLocalization],
  data() {
    return {
      loginState: LOGIN_STATES.AUTHORIZING,
      loginStates: LOGIN_STATES,
      AUTHENTICATION,
    };
  },
  mounted() {
    axios
      .post(`${process.env.VUE_APP_API}/auth/token`, {
        code: this.$route.query.code,
        state: this.$route.query.state,
      })
      .then((response) => {
        localStorage.setItem("API_CREDENTIALS", JSON.stringify(response.data));
        setTimeout(() => {
          this.$router.push({ name: "admin" });
        }, 1000);
      })
      .catch((err) => {
        this.loginState = LOGIN_STATES.FAILED;
      });
  },
};
